export const OPEN_INLINE_EDIT_FIELD = "OPEN_INLINE_EDIT_FIELD";
export const CLOSE_INLINE_EDIT_FIELD = "CLOSE_INLINE_EDIT_FIELD";
export const UPDATE_INLINE_FIELD_VALUE = "UPDATE_INLINE_FIELD_VALUE";

export const UPDATE_INLINE_FIELD_REQUEST = "UPDATE_INLINE_FIELD_REQUEST";
export const UPDATE_INLINE_FIELD_SUCCESS = "UPDATE_INLINE_FIELD_SUCCESS";
export const UPDATE_INLINE_FIELD_ERROR = "UPDATE_INLINE_FIELD_ERROR";


export const openInlineEditField = (entity, fieldName, value) => {
    return {type: OPEN_INLINE_EDIT_FIELD, payload: {entity, fieldName, value} }
}

export const closeInlineEditField = () => {
    return {type: CLOSE_INLINE_EDIT_FIELD }
}

export const updateInlineFieldValue = (value) => {
    return {type: UPDATE_INLINE_FIELD_VALUE, payload: {value} }
}

export const saveInlineField = (apiPath, entity, fieldName, value) => {
    return {
        type: 'CALL_API',
        types: [UPDATE_INLINE_FIELD_REQUEST, UPDATE_INLINE_FIELD_SUCCESS, UPDATE_INLINE_FIELD_ERROR],
        path: apiPath,
        method: 'put',
        payload: {[fieldName]: value, entity}
    };
}



// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/inlineField.js